import React from "react";

function AnnexesStatus() {
  return (
    <section>
      L’association Loi 1901 « LE MEDIA », dont la constitution a été déclarée
      le 28 octobre 2017 au Journal Officiel des Association et immatriculée au
      RNA sous le n° W751241600, a décidé de se transformer par Assemblée
      Générale Extraordinaire (AGE) du 6 juillet 2020 en Société coopérative
      d’intérêt collectif (SCIC) à forme de Société Anonyme (SA) à capital
      variable, à Conseil de Surveillance et Directoire (dualiste) selon les
      statuts suivants, qui poursuit sa personnalité morale.
      <br />
      STATUTS RÉVISÉS PAR L'ASSEMBLÉE GÉNÉRALE MIXTE DU 31/10/2025.
      <br />
      <strong>
        <a
          href="http://ressources.lemediatv.fr/cooperative/statuts.pdf"
          style={{ display: "block", marginTop: "20px", textAlign: "center" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Je consulte les statuts de la SCIC
        </a>
      </strong>
    </section>
  );
}

export default AnnexesStatus;
